import { useSelector } from 'react-redux';
import { projectActions, projectSelectors, } from '../../store/slices/projectSlice';
import { useAppDispatch } from '../../store';
export const useProjectList = (inputText) => {
    const dispatch = useAppDispatch();
    const projects = useSelector((state) => projectSelectors.selectProjectStartsWith(state, inputText));
    const removeProject = (projectName) => {
        dispatch(projectActions.removeProject(projectName));
    };
    return {
        projects,
        removeProject,
    };
};
